export function formatPrice(locale: string, amount: number, currency: string): string {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(amount);
}
